import React from 'react';
import {
  OverlayView, StyledContainer, Stack, Text, View, Layout, Card,
} from '@piwikpro/ui-components';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { withInject, view } from '@piwikpro/platform';
import { connect, ConnectedProps } from 'react-redux';
import { RouterService } from '@piwikpro/router-crate';
import { useTranslation } from 'react-i18next';
import TitleComponent from '@piwikpro/title-crate/Title';
import CookieInformationAccount from '../CookieInformationAccount/CookieInformationAccount';

const mapStateToProps = (state: { session: SessionState }) => ({
  loggedUserEmail: state.session.email,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  routerService: RouterService
  Title: typeof TitleComponent
}

interface Props extends InjectedProps, ReduxProps {}

const CookieInformationRegisterForm = ({ loggedUserEmail, Title, routerService }: Props) => {
  const { t } = useTranslation();
  return (
    <Title part={t('cookieInformation.registerForm.title')}>
      <OverlayView
        appearAnimation={false}
        isOpen
        title={t('cookieInformation.registerForm.title')}
        onClose={() => routerService.push({ to: '/' })}
      >
        <div style={{ marginTop: '55px' }}>
          <View>
            <View.Body>
              <Stack vertical horizontalAlignment="middle">
                <Stack.Item>
                  <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">
                    {t('cookieInformation.registerForm.header')}
                  </Text>
                </Stack.Item>
                <Stack.Item>
                  <Text as="p" color="InkLighter">
                    {t('cookieInformation.registerForm.description')}
                  </Text>
                </Stack.Item>
                <Stack.Item previousSpacing="extraWide" fill>
                  <Layout maxWidth="narrow">
                    <Layout.Column>
                      <StyledContainer backgroundImage="square-dot-gradient-overflowed">
                        <Card>
                          <Card.Section padding="wide">
                            <CookieInformationAccount inModal loggedUserEmail={loggedUserEmail} />
                          </Card.Section>
                        </Card>
                      </StyledContainer>
                    </Layout.Column>
                  </Layout>
                </Stack.Item>
              </Stack>
            </View.Body>
          </View>
        </div>
      </OverlayView>
    </Title>
  );
};

export default connector(withInject<InjectedProps>({
  Title: 'TitleCrate.components.Title',
  routerService: 'RouterCrate.router',
})(view({ role: 'OWNER' })(CookieInformationRegisterForm)));
